<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Addresse erstellen') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.post(route('admin.customers.addresses.store', customer))">
                <form-fields :form="form" :customer="customer" :countries="countries" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'customer',
            'countries',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    country_id: 1,
                    company: null,
                    salutation: null,
                    title: null,
                    first_name: null,
                    last_name: null,
                    city: null,
                    street: null,
                    house_number: null,
                    zip_code: null,
                    county: null,
                    phone: null,
                    notes: null,
                    default_billing_address: false,
                    default_delivery_address: false,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>